module.exports = __webpack_public_path__ + "static/media/wsymbol_0020_cloudy_with_heavy_snow_big_s1.d1b66ea6.png";